module.exports = function() {
  return new Worker(__webpack_public_path__ + "17c24a26ec93322c4dda.worker.js");
};